<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />
    <div>
      <b-card class="bCardGlobal">
        <b-row class="titulo">
          <b-col class="seccionTitulo">
          <span
          ><b-icon icon="bag-check-fill" aria-hidden="true"></b-icon
          ></span>
            <span>Bandeja de presentación PTI </span>
          </b-col>
          <b-col class="seccionCodigo">
            <div>BJ_01_HALLAZGOEE</div>
          </b-col>
        </b-row>




        <b-row v-if="$localStorageService.can('BJ_01_fecha')">
          <b-col cols="12" v-if="tipoBusqueda === 1">
            <validation-observer ref="observer" v-slot="{ handleSubmit }">
              <b-form
                  inline
              >
                <b-col cols="3">
                  <br />
                  <label>Fecha inicio:</label>
                  <br />
                  <validation-provider
                      name="validacionfechaInicio"
                      :rules="{ required: true }"
                      v-slot="motivoSlot"
                  >
                    <b-form-datepicker
                        inline
                        v-model="filtro.fechaInicio"
                        placeholder="Selecciona una fecha"
                        no-flip
                    ></b-form-datepicker>
                    <validacion
                        :texto="motivoSlot.errors[0] ? motivoSlot.errors[0] : ''"
                    ></validacion>
                  </validation-provider>
                  <br />
                  <br />
                </b-col>
                <b-col cols="3">
                  <br />
                  <label>Fecha fin:</label>
                  <br />
                  <validation-provider
                      name="validacionfechaFin"
                      :rules="{ required: true }"
                      v-slot="motivoSlot"
                  >
                    <b-form-datepicker
                        v-model="filtro.fechaFin"
                        placeholder="Selecciona una fecha"
                        no-flip
                    ></b-form-datepicker>
                    <validacion
                        :texto="motivoSlot.errors[0] ? motivoSlot.errors[0] : ''"
                    ></validacion>
                  </validation-provider>

                  <br />
                  <br />
                </b-col>
                <b-col cols="3">
                  <br />
                  <br />
                  <br />
                  <b-button pill block variant="outline-primary" type="submit"
                            @click="obtenerDatosBandeja()" :disabled="loader"
                  >Buscar</b-button
                  >
                  <br />
                  <br />
                </b-col>
              </b-form>
            </validation-observer>
          </b-col>
          <b-col cols="12" v-if="tipoBusqueda === 2">
            <validation-observer ref="observer" v-slot="{ handleSubmit }">
              <b-form
                  inline
                  @submit.stop.prevent="handleSubmit(actualizarFechas)"
              >
                <b-col cols="4">
                  <label>Id Paciente:</label>
                  <br />
                  <validation-provider
                      name="validacionIdPaciente"
                      :rules="{ required: true }"
                      v-slot="motivoSlot"
                  >
                    <b-form-input v-model="idPaciente" placeholder="Ingresa un el Id paciente"></b-form-input>

                  </validation-provider>
                  <br />
                  <br />
                </b-col>
                <b-col cols="3">
                  <br />
                  <br />
                  <br />
                  <b-button pill block variant="outline-primary" type="submit"
                            @click="obtenerDatosBandeja()" :disabled="loader"
                  >Buscar</b-button
                  >
                  <br />
                  <br />
                </b-col>
              </b-form>
            </validation-observer>
          </b-col>
        </b-row>
        <b-form-group v-slot="{ ariaDescribedbyTipoBusqueda }">
          <b-form-radio-group
              id="btn-tipos_busqueda_paciente"
              v-model="tipoBusqueda"
              :options="[
                                { text: 'Busq. por fecha', value: 1 },
                                { text: 'Busq. por ID paciente', value: 2 }
                              ]"
              :aria-describedby="ariaDescribedbyTipoBusqueda"
              button-variant="outline-primary"
              size="sm"
              name="radio-btn-outline"
          ></b-form-radio-group>
        </b-form-group>



        <b-tabs class="mt-4" >
          <b-tab v-for="(opt, index) in opciones" :key="index"
                 :title="opt.nombre"
                 @click="cambiarTab(opt.op1)"
          >
            <b-tabs content-class="mt-3" align="end" >
              <b-tab  :title="fase.nombre + ' ' + fase.value" v-for="(fase, indice) in fases"
                     :key="indice" @click="tab(fase.value)"
              >
              </b-tab>
            </b-tabs>

          </b-tab>
        </b-tabs>

        <b-row>
          <b-col cols="12">
            <b-table
                thead-tr-class="columnas"
                :items="datosBandeja"
                :fields="fields"
                :per-page="$registrosPorPaginaTabla"
                :current-page="paginaActual"
                responsive
                class="parrafos">

              <template v-slot:cell(nombrePaciente)="row">
                <BandejaLinkPacientePresentacionPTIComponente
                    :data="row"
                    :resource="row.item"
                >{{nombrePaciente}}
                </BandejaLinkPacientePresentacionPTIComponente>
              </template>

              <template v-slot:cell(dteFechaSesion)="row">
                {{row.item.dteFechaSesion | formatoFechaHora}}
              </template>

              <template v-slot:cell(dteFechaHerramienta)="row">
                {{row.item.dteFechaHerramienta | formatoFechaHora}}
              </template>

              <template v-slot:cell(dtehoraInicio)="row">
                {{row.item.dtehoraInicio | formatoFechaHora}}
              </template>

              <template v-slot:cell(dtehoraFinal)="row">
                {{row.item.dtehoraFinal | formatoFechaHora}}
              </template>

              <template v-slot:cell(observacionesDiagnostico)="row">
               <b-button
                   variant="outline-success"
                  @click="abrirModalObservaciones(row.item.observacionesDiagnostico)">
                 Observaciones
               </b-button>
              </template>

            </b-table>

            <b-pagination
                v-if="datosBandeja !== undefined && datosBandeja.length > 10"
                align="center"
                v-model="paginaActual"
                :total-rows="datosBandeja.length"
                :per-page="$registrosPorPagina"
                aria-controls="my-table1"
            ></b-pagination>

            <b-alert
                v-if="datosBandeja.length === 0 && !loader"
                show >No hay datos
            </b-alert>
            <b-spinner v-if="loader" ></b-spinner>

          </b-col>
        </b-row>






        <br/>
        <br/>
        <br/>
      </b-card>
    </div>

    <b-modal
        size="lg"
        v-model="modalComentarios"
        ref="observacionesCdx"
        title="Observaciones Cdx"
        hide-footer
    >
      <p>
        {{observacionesCdx}}
      </p>

      <br /><br/>
    </b-modal>

  </div>
</template>

<script>
import {required} from "vuelidate/lib/validators";
import Header from "../../components/Header";
import BandejaLinkPacientePresentacionPTIComponente
  from "../../components/bandejas/BandejaEmbajadorHallazgo/BandejaLinkPacientePresentacionPTIComponente";

export default {
  name: "NuevaBandejaEE",
  components: {
    Header,
    BandejaLinkPacientePresentacionPTIComponente

  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    idPaciente: null,
    paginaActual: 1,
    tipoBusqueda: 1,
    loader: false,
    idTab: 1,
    modalComentarios: false,
    observacionesCdx: null,
    fcInicio: "",
    fcFin: "",


    datosBandeja:[],
    fields:[
      { key: "nombreTipoSolicitud", label: "TipoSolicitud", sortable: true },
      /*{ key: "ultimaSolicitud", label: "Última solicitud", sortable: true },*/
      { key: "dteFechaSesion", label: "Inicio de Sesion", sortable: true },
      { key: "dteFechaHerramienta", label: "Herramientas", sortable: true },
      { key: "dtehoraInicio", label: "Cdx Inició PTI", sortable: true },
      { key: "dtehoraFinal", label: "Cdx finalizó PTI", sortable: true  },
      { key: "idPaciente", label: "Id Paciente", sortable: true },
      { key: "nombrePaciente", label: "Paciente", sortable: true },
      { key: "nombreDiagnosticador", label: "Diagnosticador", sortable: true },
      { key: "nombreSolcitante", label: "Doctor solicitante", sortable: true },
      { key: "nombreEmbajador", label: "Presentador Pti", sortable: true },
      { key: "intIdNivelPTI", label: "Nivel", sortable: true },
      { key: "observacionesDiagnostico", label: "Observaciones Diágnostico", sortable: true },
    ],

    filtro: {
      fechaInicio: "",
      fechaFin: "",
    },

    opciones:[
      {
        op1: '1',
        nombre:'Revisar',
      },
      {
        op1: '2',
        nombre:'Presentar'
      },
      {
        op1: '3',
        nombre:'Inversion'
      },
    ],

    fases: [
      {value: 1, nombre: "Pendientes"},
      {value: 2, nombre: "Actualizados"},
      {value: 3, nombre: "Modificados"},
    ],

  }),
  validations: {

    filtro: {
      fechaInicio: {required},
      fechaFin: {required},
      idsClinica: {required}
    }

  },
  methods: {

    castearFechas(){

      var dia1 = new Date(this.filtro.fechaInicio);
      dia1.setDate(dia1.getDate() + 1);
      dia1.setHours(0, 0, 0, 0);
      this.fcInicio = this.$moment(dia1).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");

      var dia2 = new Date(this.filtro.fechaFin);
      dia2.setDate(dia2.getDate() + 1);
      dia2.setHours(23, 60, 59, 999);
      this.fcFin = this.$moment(dia2).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");
    },

    obtenerDatosBandeja(){

      if (this.tipoBusqueda == 1){
        this.castearFechas();
        this.idPaciente = 0;
      }else {
        this.idPaciente;
      }


      this.loader = true;
      this.datosBandeja = [];
      const idEmpleado = this.$localStorageService.getIdEmpleado();
      const idClinica = this.$localStorageService.getIdClinica();

      var url = this.$api +
          "pti/bandeja/embajador/obtenerDatosGlobalBandeja?" +
          "fechaFinal=" +
          this.fcFin +
          "&fechaIncio=" +
          this.fcInicio +
          "&idEmpleado=" +
          idEmpleado +
          "&idClinica=" +
          idClinica +
          "&idPaciente=" +
          this.idPaciente +
          "&estatusPtiTab=" +
          this.idTab ;

      this.$http.get(url).then((resp) => {
        if (resp.status == 200){
          this.datosBandeja = resp.data.data.listaResultados;
          this.loader = false;
        }
          }).finally(() => {
            this.loader = false;
      })
    },

    cambiarTab(tab){
      if (tab == 1){
        this.fases = [
          {value: 1, nombre: "Pendientes"},
          {value: 2, nombre: "Actualizados"},
          {value: 3, nombre: "Modificados"},
        ]
      }else
      if (tab == 2){
        this.fases = [
          {value: 4, nombre: "Pendiente por presentar"},
          {value: 5, nombre: "No presentado"},
        ]
      }else if(tab ==  3){
        this.fases = [
          {value: 6, nombre: "Formas de Pago"},
          {value: 7, nombre: "Distribución"},
        ]
      }

    },
    tab(idTab){
      this.idTab = idTab;
      this.obtenerDatosBandeja();

    },

    cambioFiltro(tipoFiltro){
      if(tipoFiltro === 1){ //filtro por fechas
        this.tipoBusqueda = 1;
        this.idPaciente = 0;
      }else if(tipoFiltro === 2){ //filtro por px
        this.tipoBusqueda = 2;
        this.idPaciente = null;
      }
    },

    abrirModalObservaciones(observaciones){

      this.modalComentarios =  true;
      this.observacionesCdx = observaciones;
    },


  },
  created() {
      this.debug = this.$localStorageService.getDebug();

      this.filtro.fechaInicio = this.$moment(new Date().format("YYYY-MM-DD"))._i;
      this.filtro.fechaFin = this.$moment(new Date().format("YYYY-MM-DD"))._i;
      this.obtenerDatosBandeja();

  },
}
</script>

<style scoped>

</style>